import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom';
import {
    Button,
    Breadcrumb, Form, TextArea,
    Grid, Label, Table, Modal, Input, Checkbox, Message
} from 'semantic-ui-react';
import CustomDivider from '../../components/extras/CustomDivider';
import WebSiteData from "../../data/WebSiteData";
import helpers from "../../functions/helpers";
import connect from "react-redux/es/connect/connect";
import {showToast} from "../../actions/ToastAction";
import Loading from "../../components/extras/Loading";
import CheckPermission from "../../components/extras/CheckPermission";
import update from "react-addons-update";


class MyWeb extends Component {
    constructor() {
        super();
        this.state = {
            modal_subdomain: false,
            modal_domain: false,
            data:{
                subdomain: '',
                domain: '',
                visible: false,
                other_menu: '',
                google_analytics: '',
                has_shopping_cart: false,
                use_our_menu: true
            },
            new_subdomain: '',
            new_domain: '',
            new_google_analytics: '',
            subdomain_error: false,
            loading_subdomain: false,
            loading_google_analytics: false,
            domain: '',
            domain_error: false,
            modal_google_analytics: false,
            loading_domain: false,
            updating_other_menu: false,
            loading: true,
            token: null,
            uid: null
        }
    }

    componentDidMount() {
        this.initialFetch();
    }

    async initialFetch() {
        await WebSiteData.get(res => {
            if(!res.hasOwnProperty('detail')){
                let new_subdomain = res.data.subdomain;
                let new_google_analytics = res.data.google_analytics;
                let new_domain = res.data.domain ? res.data.domain.replace(/(^\w+:|^)\/\//, ''):'';
                this.setState({
                    data: res.data,
                    new_subdomain,
                    new_google_analytics,
                    new_domain,
                    loading: false,
                    token: res.token,
                    uid: res.uid
                });
            }
        });
    };

    handleSubdomainChange = (event) =>{
        let new_subdomain = helpers.slugify(event.target.value);
        this.setState({new_subdomain});
        if(new_subdomain === ""){
            this.setState({subdomain_error:true})
        }else{
            this.setState({subdomain_error:false})
        }
    };

    handleDomainChange = (event) =>{
        let new_domain = event.target.value;
        this.setState({new_domain});
        if(new_domain === ""){
            this.setState({domain_error:true})
        }else{
            this.setState({domain_error:false})
        }
    };

    handleGoogleAnalyticsChange = (event) =>{
        let new_google_analytics = event.target.value.trim();
        this.setState({new_google_analytics});
    };

    submitSubdomain = () =>{
        if(this.state.new_subdomain.trim() === ""){
            this.setState({subdomain_error:true})
        }else{
            this.setState({loading_subdomain:true});
            let data = this.state.data;
            data.subdomain = this.state.new_subdomain;
            WebSiteData.update(data, res =>{
                if(res && res.update){
                    this.setState({data:res.data});
                    this.closeModalSubdomain();
                    this.props.showToast({message:'Subdominio actualizado!', type:'success'});
                }else{
                    this.props.showToast({message:'Este subdominio ya está en uso, intente con otro!', type:'error'});
                }
            }).catch(()=>{
                this.props.showToast({message:'Este subdominio ya está en uso, intente con otro!', type:'error'});
            }).finally(()=>{
                this.setState({loading_subdomain:false});
            })
        }
    };

    submitDomain = () =>{
        let domain =  `https://${this.state.new_domain}`;
        if(domain === "" || !helpers.is_valid_url(domain)){
            this.setState({domain_error:true})
        }else{
            this.setState({loading_domain:true});
            let data = this.state.data;
            data.domain = domain;
            WebSiteData.update(data, res =>{
                if(res && res.update){
                    this.setState({data:res.data});
                    this.closeModalDomain();
                    this.props.showToast({message:'Dominio actualizado!', type:'success'});
                }else{
                    this.props.showToast({message:'Este dominio ya está en uso, intente con otro!', type:'error'});
                }
            }).catch(()=>{
                this.props.showToast({message:'Este dominio ya está en uso, intente con otro!', type:'error'});
            }).finally(()=>{
                this.setState({loading_domain:false});
            })
        }
    };

    submitGoogleAnalytics = () =>{
        this.setState({loading_google_analytics:true});
        let data = this.state.data;
        data.google_analytics = this.state.new_google_analytics.trim();
        WebSiteData.update(data, res =>{
            if(res && res.update){
                this.setState({data:res.data});
                this.closeModalDomain();
                this.props.showToast({message:'Código de Google Analytics actualizado!', type:'success'});
            }else{
                this.props.showToast({message:'Tenemos un problema!', type:'error'});
            }
        }).catch(()=>{
            this.props.showToast({message:'Tenemos un problema!', type:'error'});
        }).finally(()=>{
            this.setState({loading_google_analytics:false, modal_google_analytics:false});
        })
    };

    closeModalSubdomain = () =>{
        this.setState({
            modal_subdomain: false,
            new_subdomain: this.state.data.subdomain,
            subdomain_error: false
        });
    };

    closeModalDomain = () =>{
        this.setState({
            modal_domain: false,
            new_domain: this.state.data.domain,
            domain_error: false
        });
    };

    closeModalGoogleAnalytics = () =>{
        this.setState({
            modal_google_analytics: false,
            new_google_analytics: this.state.data.google_analytics,
        });
    };

    handleVisible = () => {
        let data = this.state.data;
        data.visible = !data.visible;
        this.setState({data});
        WebSiteData.update(data, res =>{
            if(res && res.update){
                this.setState({data:res.data});
                this.closeModalDomain();
                this.props.showToast({message:'Estado actualizado!', type:'success'});
            }else{
                this.props.showToast({message:'Tenemos un problema!', type:'error'});
            }
        }).catch(()=>{
            this.props.showToast({message:'Tenemos un problema!', type:'error'});
        });
    };

    handleUseOurMenu = () => {
        let data = this.state.data;
        data.use_our_menu = !data.use_our_menu;
        this.setState({data});
        WebSiteData.update(data, res =>{
            if(res && res.update){
                this.setState({data:res.data});
                this.closeModalDomain();
                this.props.showToast({message:'Menu actualizado!', type:'success'});
            }else{
                this.props.showToast({message:'Tenemos un problema!', type:'error'});
            }
        }).catch(()=>{
            this.props.showToast({message:'Tenemos un problema!', type:'error'});
        });
    };

    handleShoppingCart = () => {
        let data = this.state.data;
        data.has_shopping_cart = !data.has_shopping_cart;
        this.setState({ data });
        WebSiteData.update(data, res => {
            if (res.update) {
                this.setState({ data: res.data });
                this.closeModalDomain();
                this.props.showToast({ message: 'Estado actualizado!', type: 'success' });
            } else {
                this.props.showToast({ message: 'Tenemos un problema!', type: 'error' });
            }
        }).catch(() => {
            this.props.showToast({ message: 'Tenemos un problema!', type: 'error' });
        });
    };

    handleOtherMenu = () => {
        let data = this.state.data;
        this.setState({ updating_other_menu:true });
        WebSiteData.update(data, res => {
            if (res.update) {
                this.setState({ data: res.data });
                this.props.showToast({ message: 'Código actualizado!', type: 'success' });
            } else {
                this.props.showToast({ message: 'Tenemos un problema!', type: 'error' });
            }
        }).catch(() => {
            this.props.showToast({ message: 'Tenemos un problema!', type: 'error' });
        }).finally(() => this.setState({ updating_other_menu:false }));
    };

    openThemeManager = () =>{
        console.log(`https://${this.state.data.subdomain}.mybisttros.com/theme-manager/auth?token=${this.state.token}&uid=${this.state.uid}`)
        Object.assign(document.createElement('a'), {
            target: '_blank',
            href: `https://${this.state.data.subdomain}.mybisttros.com/theme-manager/auth?token=${this.state.token}&uid=${this.state.uid}`
        }).click();
    };

    handleOtherMenuChange = (event) => {
        let other_menu = update(this.state, {
            data: {
                other_menu: {
                    $set: event.target.value
                }
            }
        });
        this.setState(other_menu);
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Mi Sitio Web | Configuraciones - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/settings'>Configuraciones</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Mi Sitio Web</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <Grid>
                    {!this.state.loading ?<Grid.Row>
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                            <Table celled>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={3} textAlign='center'>Configuraciones de Mi Sitio
                                            Web</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell><strong>Subdominio</strong></Table.Cell>
                                        <Table.Cell>
                                            <a href={`https://${this.state.data.subdomain}.mybisttros.com`} target='_blank'>{`${this.state.data.subdomain}.mybisttros.com`}</a>
                                            </Table.Cell>
                                        <Table.Cell>
                                            <Button.Group basic size='tiny'>
                                                <Button icon='pencil'
                                                        onClick={() => this.setState({modal_subdomain: true})}/>
                                            </Button.Group>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><strong>Dominio</strong></Table.Cell>
                                        <Table.Cell><a href={this.state.data.domain} target='_blank'>{this.state.data.domain ? this.state.data.domain.replace(/(^\w+:|^)\/\//, ''):'No Aplica'}</a></Table.Cell>
                                        <Table.Cell>
                                            <Button.Group basic size='tiny'>
                                                <Button icon='pencil' onClick={() => this.setState({modal_domain: true})}/>
                                            </Button.Group>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><strong>Código de Google Analytics</strong></Table.Cell>
                                        <Table.Cell>{this.state.data.google_analytics}</Table.Cell>
                                        <Table.Cell>
                                            <Button.Group basic size='tiny'>
                                                <Button icon='pencil' onClick={() => this.setState({modal_google_analytics: true})}/>
                                            </Button.Group>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><strong>Estado</strong></Table.Cell>
                                        <Table.Cell colSpan={2}>
                                            <Checkbox  toggle checked={this.state.data.visible} label={`Restaurante ${this.state.data.visible ? 'Visible' : 'Oculto'}`} onChange={this.handleVisible}/>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><strong>Carrito de Compras</strong></Table.Cell>
                                        <Table.Cell colSpan={2}>
                                            <Checkbox toggle checked={this.state.data.has_shopping_cart} label={`Carrito de Compras ${this.state.data.has_shopping_cart ? 'Visible' : 'Oculto'}`} onChange={this.handleShoppingCart} />
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><strong>Diseño</strong></Table.Cell>
                                        <Table.Cell colSpan={2}><Button onClick={this.openThemeManager} primary>Ir al Administardor de Estilos</Button></Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><strong>Usar el menú de Bisttros</strong></Table.Cell>
                                        <Table.Cell colSpan={2}>
                                            <Checkbox  toggle checked={this.state.data.use_our_menu} label={`${this.state.data.use_our_menu ? 'Si' : 'No'}`} onChange={this.handleUseOurMenu}/>
                                        </Table.Cell>
                                    </Table.Row>
                                    {!this.state.data.use_our_menu ? <Table.Row>
                                        <Table.Cell><strong>Código Externo</strong></Table.Cell>
                                        <Table.Cell colSpan={2}>
                                            <Form>
                                                <TextArea label='Código Externo' placeholder='Código Externo' value={this.state.data.other_menu} onChange={this.handleOtherMenuChange}/>
                                                <p>
                                                    <Button primary icon='save' fluid labelPosition='left' disabled={this.state.updating_other_menu}
                                                            loading={this.state.updating_other_menu} onClick={this.handleOtherMenu}
                                                            content='Actualizar'/>
                                                </p>
                                            </Form>
                                        </Table.Cell>
                                    </Table.Row>:null}
                                </Table.Body>
                            </Table>
                        </Grid.Column>
                    </Grid.Row>:<Grid.Row centered><Loading/></Grid.Row>}
                </Grid>
                <Modal size='tiny' dimmer='inverted' open={this.state.modal_subdomain}
                       onClose={this.closeModalSubdomain}>
                    <Modal.Header>Actualizar Subdominio</Modal.Header>
                    <Modal.Content>
                            <Input
                                labelPosition='right'
                                type='text'
                                placeholder='Subdominio'
                                value={this.state.new_subdomain}
                                error={this.state.subdomain_error}
                                onChange={this.handleSubdomainChange}
                            >
                                <Label basic>https://</Label>
                                <input/>
                                <Label>.mybisttros.com</Label>
                            </Input>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={this.closeModalSubdomain}>Cancelar</Button>
                        <Button primary content='Actualizar' onClick={this.submitSubdomain} disabled={this.state.loading_subdomain} loading={this.state.loading_subdomain}/>
                    </Modal.Actions>
                </Modal>

                <Modal size='tiny' dimmer='inverted' open={this.state.modal_domain}
                       onClose={this.closeModalDomain}>
                    <Modal.Header>Actualizar Dominio</Modal.Header>
                    <Modal.Content>
                        <Input label='https://' placeholder='ejemplo.com'
                               value={this.state.new_domain ? this.state.new_domain.replace(/(^\w+:|^)\/\//, ''):''}
                               error={this.state.domain_error}
                               onChange={this.handleDomainChange}
                        />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={this.closeModalDomain}>Cancelar</Button>
                        <Button primary content='Actualizar' onClick={this.submitDomain} disabled={this.state.loading_domain} loading={this.state.loading_domain}/>
                    </Modal.Actions>
                </Modal>

                <Modal size='tiny' dimmer='inverted' open={this.state.modal_google_analytics}
                       onClose={this.closeModalGoogleAnalytics}>
                    <Modal.Header>Código de Usuario de Google Analytics</Modal.Header>
                    <Modal.Content>
                        <Input placeholder='UA-XXXXX-X'
                               icon='chart line'
                               fluid
                               iconPosition='left'
                               value={this.state.new_google_analytics}
                               onChange={this.handleGoogleAnalyticsChange}
                        />
                        <Message>
                            <p>
                                Es una herramienta de Google que te permite monitorear tu sitio web para saber la cantidad de visitas, páginas más visitas entre otros informes
                            </p>
                            <p>
                                <a href='https://analytics.google.com' rel="noopener noreferrer"  target='_blank'>Aún no tengo mi cuenta de Google Analytics</a>
                            </p>
                        </Message>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={this.closeModalGoogleAnalytics}>Cancelar</Button>
                        <Button primary content='Actualizar' onClick={this.submitGoogleAnalytics} disabled={this.state.loading_google_analytics} loading={this.state.loading_google_analytics}/>
                    </Modal.Actions>
                </Modal>
                <CheckPermission access='website_edit'/>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        showToast(toast){
            dispatch(showToast(toast))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(MyWeb)



// WEBPACK FOOTER //
// ./src/containers/settings/MyWeb.js